<template>
  <div>
    <div class="profile-field__title">Автомобиль</div>
    <div class="wrapper">
      <div><c-switcher v-model="hasAuto" label="Есть автомобиль" /></div>

      <transition name="slide">
        <div v-if="hasAuto" class="params">
          <div class="param brand">
            <c-input v-model="brand" floating-label="Марка" :clearable="true" :max-length="255" />
          </div>
          <div class="param model">
            <c-input v-model="model" floating-label="Модель" :clearable="true" :max-length="255" />
          </div>
          <div class="param year">
            <c-input
              v-model="year"
              type="price-number"
              :fractional-length="0"
              floating-label="Год выпуска"
              :clearable="true"
              :max-length="4"
              :required="error && error.year"
              :required-message="error && error.year"
              :required-condition="error && error.year"
            />
          </div>
          <div class="param category">
            <c-input v-model="category" floating-label="Категория прав" :clearable="true" :max-length="255" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";
import CInput from "@/components/controls2/Input";

export default {
  components: { CSwitcher, CInput },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      hasAuto: false,
      brand: "",
      model: "",
      year: "",
      category: "",
    };
  },

  watch: {
    hasAuto(v) {
      if (!v) {
        this.brand = "";
        this.model = "";
        this.year = "";
        this.category = "";
      }
      this.updateValue();
    },
    brand() {
      this.updateValue();
    },
    model() {
      this.updateValue();
    },
    year() {
      this.updateValue();
    },
    category() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { hasAuto, brand, model, year, category } = value.value || {};

      this.hasAuto = hasAuto === "0" ? false : !!hasAuto;
      this.brand = brand || "";
      this.model = model || "";
      this.year = year || "";
      this.category = category || "";

      this.$nextTick(() => {
        this.inited = true;
      });
    },

    updateValue() {
      this.$emit("input", {
        value: {
          hasAuto: this.hasAuto ? 1 : 0,
          brand: this.brand,
          model: this.model,
          year: this.year,
          category: this.category,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.params {
  display: flex;
  flex-wrap: wrap;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -20px;
  margin-top: 24px;
}

.param {
  padding: 0 8px 20px;
}

.brand,
.model {
  width: 100%;
}

.year,
.category {
  width: 50%;
}

@include bootstrapMd {
  .params {
    margin-left: -15px;
    margin-right: -15px;
  }

  .param {
    padding-left: 15px;
    padding-right: 15px;
  }

  .brand,
  .model {
    width: calc(100% / 10 * 3);
  }

  .year,
  .category {
    width: calc(100% / 10 * 2);
  }

  .year {
    margin-right: calc(100% / 10);
  }
}

@include bootstrapLg {
  .brand,
  .model {
    width: calc(100% / 12 * 3);
  }

  .year,
  .category {
    width: calc(100% / 12 * 2);
  }

  .year {
    margin-right: 0;
  }
}
</style>
